<p-dialog
  [visible]="isBlocked()"
  [modal]="true"
  [closable]="false"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
  [showHeader]="false"
  styleClass="update-required-dialog"
  [breakpoints]="{ '576px': '92vw' }"
  [style]="{ width: '380px' }"
>
  <div class="update-required-content" dir="auto">
    <h1 class="title">{{ 'force-update.title' | translate }}</h1>
    <p class="message">{{ 'force-update.message' | translate }}</p>

    <a class="btn btn-primary" [href]="storeUrl()" target="_system" rel="noopener noreferrer">
      {{ 'force-update.update_btn' | translate }}
    </a>
  </div>
</p-dialog>
